import { Component, OnInit, Input } from '@angular/core';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { IStore } from '../../services/store.service';
import { ICheckoutTipForm } from '../../forms/checkout-tip-form/checkout-tip-form.component';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ICheckoutTermsAgreementForm } from '../../forms/checkout-terms-agreement-form/checkout-terms-agreement-form.component';
import { ICheckoutNoteForm } from '../../forms/checkout-order-note-form/checkout-order-note-form.component';
import { ICheckoutPersonalInfoForm } from '../../forms/checkout-personal-info-form/checkout-personal-info-form.component';
import { ICreditCardCvc } from 'src/app/account/services/credit-card.service';
//import * as momentTz from 'moment-timezone';
import momentTz from 'moment-timezone';
import { IAddress } from 'src/app/shared/services/address.service';
import { Storage } from '@ionic/storage';
import { AlertService } from 'src/app/shared/services/alert.service';
import { LoaderService } from 'src/app/shared/services/loader.service';

import { finalize } from 'rxjs/operators';
import { ICheckoutGiftCardForm } from '../../forms/checkout-gift-card-form/checkout-gift-card-form.component';

import { ICreditCardForm } from 'src/app/shared/forms/credit-card-form/credit-card-form.component';
//import { ThrowStmt } from '@angular/compiler';
//import * as moment from 'moment';
import moment from 'moment';
import { ProfileService, IProfile } from 'src/app/account/services/profile.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { AlertController } from '@ionic/angular';
import { IDoorDashDriveNotificationForm } from '../../forms/checkout-doordash-drive-form/checkout-doordash-drive-form.component';
import { ModalDisplayComponent } from 'src/app/shared/components/modal-display/modal-display.component';
import { IMemberPlacePrepayReservation, IPlacePrepayReservation, IReservation, IReservationSectionPackage, ReservationService } from 'src/app/shared/services/reservation.service';
import { IReservationCheckoutTotalOptions } from '../../components/reservation-checkout-total/reservation-checkout-total.component';
import { TranslationService } from 'src/app/shared/services/translation.service';


@Component({
    selector: 'reservation-checkout-modal',
    templateUrl: './reservation-checkout-modal.component.html',
    styleUrls: ['./reservation-checkout-modal.component.scss'],
    standalone: false
})
export class ReservationCheckoutModalComponent implements OnInit  {

  @Input() reservationSectionPackages: IReservationSectionPackage[];
  @Input() reservationTime: string;
  @Input() reservationDate: string;
  @Input() specialRequest: string;
  @Input() store: IStore;

  submitted: boolean = false;
  clickedSubmitted: boolean = false;
  total: number = 0;
  shippingPrice: number;
  tip: number = 0;
  termsAgreement: ICheckoutTermsAgreementForm;
  checkoutNote: ICheckoutNoteForm;
  personalInformation: ICheckoutPersonalInfoForm;
  giftCard: ICheckoutGiftCardForm;
  eCouponCode: string;
  discountAmount: number=0;
  memberCreditCard: ICreditCardCvc;
  guestCreditCard: ICreditCardForm;
  guestBillingAddress: IAddress;
  shippingAddress: IAddress;
  profile: IProfile;
  SendNotificationAgreement:boolean ; 

  warningModal: HTMLIonModalElement = null;

  get isGiftCardFullyCover() {
    if (!this.giftCard)
    
      return false;

    if (this.giftCard.use && this.giftCard.remainingBalance <= 0)
      return true;

    return false;
  }
  getDiscountAmount(discountInfo: any)
  {

    this.discountAmount= discountInfo.amount;
    this.eCouponCode = discountInfo.couponNumber;

  }
  get isFormValid() {
    if (!this.termsAgreement || !this.termsAgreement.agreement)
      return false;

    if (!this.personalInformation || !this.personalInformation._valid) {
      this.alertService.showTranslate('Checkout.InvalidPersonnalInformation', 'bottom', 6000, 'danger');  
      return false;
    }

    if (this.auth.isAuthenticated && (!this.isGiftCardFullyCover && !this.memberCreditCard)) {
      this.alertService.showTranslate('Checkout.NoCreditCardSelected', 'bottom', 6000, 'danger');  
      return false;
    }
    else if (!this.auth.isAuthenticated) {
      if (!this.isGiftCardFullyCover && (!this.guestBillingAddress || !this.guestCreditCard || !this.guestCreditCard._valid)) {
        if (!this.guestCreditCard || !this.guestCreditCard._valid) {
          this.alertService.showTranslate('Checkout.InvalidPaymentInformation', 'bottom', 6000, 'danger');  
        } else if (!this.guestBillingAddress || !this.guestBillingAddress.postalCode) {
          this.alertService.showTranslate('Checkout.InvalidBillingAddress', 'bottom', 6000, 'danger');  
        }
        
        return false;
      }
    }
   
    return true;
  }

  get memberForm(): IMemberPlacePrepayReservation {
    let cvn = null;
    let cardId = null;
    let giftCard = null;
    if (this.memberCreditCard) {
      cvn = this.memberCreditCard.Cvc;
      cardId = this.memberCreditCard.Card.Id;
    }

    if (this.giftCard) {
      giftCard = this.giftCard.cardNumber;
    }

    let reservation: IReservation = {
      packages: this.reservationSectionPackages,
      specialRequest: this.specialRequest
    } 
    
    return {
      customerName: `${this.personalInformation.firstName} ${this.personalInformation.lastName}`,
      customerFirstName: this.personalInformation.firstName,
      customerLastName: this.personalInformation.lastName,
      cvn: cvn,
      customerEmail: this.personalInformation.email,
      language: this.translationService.getLanguage(),
      merchantId: this.store.merchantId,
      storeId: this.store.id,
      reservation: reservation,
      phone: this.personalInformation.phone,
      reservationTip: this.tip,
      savedCardId: cardId,
      giftCard: giftCard,
      eCouponCode: this.eCouponCode,
      reservationDate: this.reservationDate,
      reservationTime: this.reservationTime,
      convenienceFee : this.store.convenienceFee
    };
  }

  get guestForm(): IPlacePrepayReservation {
    let giftCard = null;

    if (this.giftCard) {
      giftCard = this.giftCard.cardNumber;
    }

    let reservation: IReservation = {
      packages: this.reservationSectionPackages,
      specialRequest: this.specialRequest
    } 
    
    return {
      customerName: `${this.personalInformation.firstName} ${this.personalInformation.lastName}`,
      customerFirstName: this.personalInformation.firstName,
      customerLastName: this.personalInformation.lastName,
      customerEmail: this.personalInformation.email,
      language: this.translationService.getLanguage(),
      merchantId: this.store.merchantId,
      storeId: this.store.id,
      reservation: reservation,
      phone: this.personalInformation.phone,
      reservationTip: this.tip,
      giftCard: giftCard,
      creditCard: {
        cardHolderName: this.guestCreditCard.fullName,
        cvnNumber: this.guestCreditCard.cvc,
        expirationDate: moment(this.guestCreditCard.expirationDate).format("YYYY-MM-DD"),
        number: this.guestCreditCard.number,
        type: this.guestCreditCard.type
      },
      billingAddress: this.guestBillingAddress,
      eCouponCode: this.eCouponCode,
      reservationDate: this.reservationDate,
      reservationTime: this.reservationTime,
      convenienceFee : this.store.convenienceFee
    };
  }

  get subTotal(): number {
    let subTotal = 0;
    this.reservationSectionPackages.forEach(p => {
      if(p){
        subTotal += p.Price * p.Quantity;
      }
    });
    return subTotal;
  }

  get totalOptions(): IReservationCheckoutTotalOptions {
    return {
      subTotal: this.subTotal,
      taxes: this.store.provinceTaxes,
      convenienceFee : this.store.convenienceFee,
      tip: this.tip
    };
  }

  get secureUrl() {
    return `assets/imgs/checkout/Secure-SSL-${this.translationService.getLanguage()}.png`;
  }

  constructor(
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    //private translateService: TranslateService,
    public auth: AuthService,
    private storage: Storage,
    private reservationService: ReservationService,
    private toastCtrl: ToastController,
    private loader: LoaderService,
    private profileService: ProfileService,
    private alertService:AlertService,
    public settingService: SettingService,
    private loadingCtrl: LoadingController,
    private translationService: TranslationService
    ) {
  }

  ngOnInit() {
    localStorage['ReservationStoreId'] = this.store.id;
  }

  searchCoupon(e)
  {
    this.cancel();
  }
  onGiftCardChange(form: ICheckoutGiftCardForm) {
    this.giftCard = form;
  }

  onShippingCalculated(shippingPrice: number) {
    this.shippingPrice = shippingPrice;
  }

  onTotalChanged(total: number) {
    this.total = total;
  }

  onTipChanged(form: ICheckoutTipForm) {
    this.tip = form.amount;
  }

  onTermsAgreementChanged(form: ICheckoutTermsAgreementForm) {
    this.termsAgreement = form;
  }

  onPersonalInfoFormChanged(form: ICheckoutPersonalInfoForm) {
    this.personalInformation = form;
  }

  onGuestCreditCardChanged(form: ICreditCardForm) {
    this.guestCreditCard = form;
  }

  onBillingAddressChanged(address: IAddress) {
    this.guestBillingAddress = address;
  }

  onMemberCreditCardChanged(card: ICreditCardCvc) {
    this.memberCreditCard = card;
  }

  onCheckoutNoteChange(form: ICheckoutNoteForm) {
    this.checkoutNote = form;
  }
  async cancel() {
    await this.modalCtrl.dismiss(null);
  }
  alertNoDelivery()
  {
    this.alertCtrl.create({
      header: this.translationService.translate('Checkout.WrongPostalCodeHeading'),
      message: this.translationService.translate('Checkout.WrongPostalCode'),
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            
          }
        }
      ]
    }).then(al=>{
      al.present();
    });
  }
  async memberPay() {

   const loader = await this.loadingCtrl.create(
     {
       message: this.translationService.translate("General.RefreshWarning")       
     }
   );

   await loader.present();
    
  
    this.reservationService
      .memberPlacePrepayReservation(this.memberForm)
      .pipe(finalize(async () => {
        await loader.dismiss();
        this.clickedSubmitted = false;
        //await this.warningModal.dismiss();
      }))
      .subscribe(async response => {
        this.submitted = false;
       // await this.warningModal.dismiss();
        if (!response || response.errorMessage != null) {

            const toast = await this.toastCtrl.create({
              message: this.translationService.translate("Checkout.InvalidOrder"),
              position: 'bottom',
              color: 'danger',
              cssClass: 'order-toast',
              buttons: [
                {
                  side: 'start',
                  icon: 'alert-circle-outline',
                  //cssClass: 'order-error-icon',
                  text: '',
                  handler: () => {
    
                  }
                }, {
                  text: this.translationService.translate("General.Close"),
                  role: 'cancel',
                  handler: () => {
    
                  }
                }
              ]
            });

            if (response.errorMessage.toLowerCase().includes("storeisclosed")) {
              toast.message = this.translationService.translate("Checkout.StoreIsClosed");
            }
            if (response.errorMessage.toLowerCase().includes("alreadyprocessed")) {
              toast.message = this.translationService.translate("Checkout.AlreadyProcessed");
            }
            if (response.errorMessage.toLowerCase().includes("strictbillingaddresserror")) {
              toast.message = this.translationService.translate("Checkout.StrictBillingAddressError");
            }
            await toast.present();
            return;
          
        }

        if (response.isBlockedCard) {
          const toast = await this.toastCtrl.create({         
              message: this.translationService.translate("Checkout.BlockedCard"),
              position: 'bottom',
              color: 'danger',
              cssClass: 'order-toast',
              buttons: [
                {
                  side: 'start',
                  icon: 'alert-circle-outline',
                  //cssClass: 'order-error-icon',                
                  text: '',
                  handler: () => {
                    
                  }
                }, {
                  text: this.translationService.translate("General.Close"),
                  role: 'cancel',
                  handler: () => {
                   
                  }
                }
              ]
            });
            toast.present();
            return;
        }

        if (response.isBlockedEmail) {
          const toast = await this.toastCtrl.create({         
              message: this.translationService.translate("Checkout.BlockedEmail"),
              position: 'bottom',
              color: 'danger',
              cssClass: 'order-toast',
              buttons: [
                {
                  side: 'start',
                  icon: 'alert-circle-outline',
                  //cssClass: 'order-error-icon',                
                  text: '',
                  handler: () => {
                    
                  }
                }, {
                  text: this.translationService.translate("General.Close"),
                  role: 'cancel',
                  handler: () => {
                   
                  }
                }
              ]
            });
            toast.present();
            return;
        }       

        if (response) {
          await this.modalCtrl.dismiss(response);
          return;
        } 
        const toast = await this.toastCtrl.create({
          message: this.translationService.translate("Checkout.InvalidOrder"),
          position: 'bottom',
          color: 'danger',
          cssClass: 'order-toast',
          buttons: [
            {
              side: 'start',
              icon: 'alert-circle-outline',
              //cssClass: 'order-error-icon',
              text: '',
              handler: () => {

              }
            }, {
              text: this.translationService.translate("General.Close"),
              role: 'cancel',
              handler: () => {

              }
            }
          ]
        });
        await toast.present();
      });
  
}

  async guestPay() {
   /* const loader = await this.loader.create();
    await loader.present();*/

    const loader = await this.loadingCtrl.create(
      {
        message: this.translationService.translate("General.RefreshWarning")       
      }
    );
 
    await loader.present();
      this.reservationService
        .placePrepayReservation(this.guestForm)
        .pipe(finalize(async () => {
          await loader.dismiss();
          this.clickedSubmitted = false;
          //await this.warningModal.dismiss();
        }))
        .subscribe(async response => {
          this.submitted = false;
        // await this.warningModal.dismiss();
          if (!response || response.errorMessage != null) {
            const toast = await this.toastCtrl.create({
              message: this.translationService.translate("Checkout.InvalidOrder"),
              position: 'bottom',
              color: 'danger',
              cssClass: 'order-toast',
              buttons: [
                {
                  side: 'start',
                  icon: 'alert-circle-outline',
                  //cssClass: 'order-error-icon',
                  text: '',
                  handler: () => {
    
                  }
                }, {
                  text: this.translationService.translate("General.Close"),
                  role: 'cancel',
                  handler: () => {
    
                  }
                }
              ]
            });
            if(response.errorMessage.toLowerCase().includes("doordash drive") || response.errorMessage.toLowerCase().includes("doordashdelivery")){
              toast.message = this.translationService.translate("Checkout.DoorDashDriveNotAvailable");
            }
            if(response.errorMessage.toLowerCase().includes("failed doordash drive validation")){
              toast.message = this.translationService.translate("Checkout.DoorDashDriveValidationError"); 
            }
            if(response.errorMessage.toLowerCase().includes("unable to create order with doordash drive")){
              toast.message = this.translationService.translate("Checkout.DoorDashDriveCreationError"); 
            }

            if (response.errorMessage.toLowerCase().includes("storeisclosed")) {
              toast.message = this.translationService.translate("Checkout.StoreIsClosed");
            }
            if (response.errorMessage.toLowerCase().includes("alreadyprocessed")) {
              toast.message = this.translationService.translate("Checkout.AlreadyProcessed");
            }

            await toast.present();
            return;
          }

          if (response.isBlockedCard) {
            const toast = await this.toastCtrl.create({         
                message: this.translationService.translate("Checkout.BlockedCard"),
                position: 'bottom',
                color: 'danger',
                cssClass: 'order-toast',
                buttons: [
                  {
                    side: 'start',
                    icon: 'alert-circle-outline',
                    //cssClass: 'order-error-icon',                
                    text: '',
                    handler: () => {
                      
                    }
                  }, {
                    text: this.translationService.translate("General.Close"),
                    role: 'cancel',
                    handler: () => {
                    
                    }
                  }
                ]
              });
              toast.present();
              return;
          }

          if (response.isBlockedEmail) {
            const toast = await this.toastCtrl.create({         
                message: this.translationService.translate("Checkout.BlockedEmail"),
                position: 'bottom',
                color: 'danger',
                cssClass: 'order-toast',
                buttons: [
                  {
                    side: 'start',
                    icon: 'alert-circle-outline',
                    //cssClass: 'order-error-icon',                
                    text: '',
                    handler: () => {
                      
                    }
                  }, {
                    text: this.translationService.translate("General.Close"),
                    role: 'cancel',
                    handler: () => {
                    
                    }
                  }
                ]
              });
              toast.present();
              return;
          }
        
          if (response) {
            await this.modalCtrl.dismiss(response);
            return;
          }        
        
        });
  }

  pay() {
    //Valid if we have all the info
    this.submitted = true;
    this.clickedSubmitted = true;
    
    if (this.isFormValid) {       
      //Only proceed when all forms are valids
      if (this.auth.isAuthenticated) {
        
        if(this.memberCreditCard)
        {
          if (this.memberCreditCard.Card) {
             
          if(this.store.address.province != this.memberCreditCard.Card.Address.province)
          {
            let addressValid = 1;
            //Store logic
             if(this.store.allowedProvince != null)
             { 
               if(!this.store.allowedProvince.allowOtherProvince)
               {
                   this.alertNoDelivery();
                   return;
               }
               else 
               {
                  addressValid = this.store.allowedProvince.allowedProvinces.findIndex(province=>province == this.memberCreditCard.Card.Address.province);
                  if(addressValid < 0)
                  { 
                    this.alertNoDelivery();
                    return;
                  }
               }
             }
             //Merchant Logic
             else 
             {
               if(this.settingService.configuration.allowedProvince != null)
               {
                if(!this.settingService.configuration.allowedProvince.allowedProvinces)
                {
                    this.alertNoDelivery();
                    return;
                }
                else
                {
                  addressValid = this.settingService.configuration.allowedProvince.allowedProvinces.findIndex(province=>province==this.memberCreditCard.Card.Address.province);
                  if(addressValid < 0)
                  { 
                    this.alertNoDelivery();
                    return;
                  }
                }
              }
           }
          }
        }
      }
        if (!this.isGiftCardFullyCover && !this.memberCreditCard) {
          this.alertService.showTranslate('Checkout.NoCreditCardSelected', 'bottom', 6000, 'danger'); 
          this.submitted = false;
        }
        else {
          this.memberPay();        
        }     
        return;
      }

      this.guestPay();
    }  else {
      this.clickedSubmitted = false;
    }

  }
}